import { setCookie } from "./cookie";

const broadcastChannel = new BroadcastChannel('my_channel');

export const sendMessage = (data: any) => {
  // console.log('message', data)
  setCookie('credits_limit', data?.credits_limit);
  setCookie('credits', data?.credits);
  setCookie('point', data?.point);
  setCookie('point_foreign', data?.point_foreign);
  setCookie('point_stock', data?.point_stock);
  if (broadcastChannel) {
    // console.log('data',data)
    broadcastChannel.postMessage(data);
  } else {
    console.error('Channel is closed');
  }
  // broadcastChannel.postMessage(data);
};

export const receiveMessage = (callback: any) => {
 const handleMessage = (event: any) => {
   callback(event.data);
 };

 broadcastChannel.addEventListener('message', handleMessage);

 return () => {
   broadcastChannel.removeEventListener('message', handleMessage);
 };
};


export const closeChannel = () => {
 // console.log('Closing channel');
 broadcastChannel.close();
};


